<template>
  <b-col md="12">
    <section class="thankyou">
      <h1 class="thankyou__title">Complimenti!</h1>
      <p class="thankyou__subtitle">La tua prenotazione è confermata.</p>
      <div class="thankyou__info">
        <div class="d-flex align-items-center">
          <vb-icon class="thankyou__info-icon mr-1" :name="'hotel'" :color="sass('info')" :size="18" />
          <h2 class="thankyou__info-title">Potrai presentarti in struttura con questa Conferma.</h2>
        </div>
        <p class="thankyou__info-text">
          <strong>
            Contatteremo di nuovo la struttura prima del tuo arrivo per assicurarci che sia tutto pronto
            per accoglierti.
          </strong>
          <br>
          <span>
            Abbiamo inviato all'indirizzo <strong>{{confirm.epsVoucher.email}}</strong>
            il riepilogo e l'estratto conto della prenotazione.
          </span>
          <br><br>
          <strong>Non esitare a contattarci per qualsiasi informazione o supporto.</strong>
        </p>
      </div>
      <template v-if="double_checked">
        <p class="thankyou__print">
          <vb-icon class="thankyou__info-icon mr-1" :name="'print'" :color="sass('info')" :size="18" />
          <span @click="window.print()">Stampa la conferma da presentare in hotel</span>
        </p>
        <p class="thankyou__ambient">
          <vb-icon class="thankyou__info-icon mr-1" :name="'leaf'" :color="sass('success')" :size="13" />
          <span>
            Pensa all'ambiente. Stampa solo se necessario, ti ricordiamo che potrai presentare la Conferma anche
            da un dispositivo mobile.
          </span>
        </p>
      </template>
    </section>
  </b-col>
</template>

<script>

export default {
  inheritAttrs: false,
  name: 'thankyou',

  components: {
  },

  props: {
    double_checked: Boolean,
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .thankyou {
    margin-bottom: $grid-gutter-width;

    @include media-breakpoint-up(lg) {
      margin-bottom: $grid-gutter-width*2;
    }

    &__title {
      margin-bottom: 0;
      color: var(--primary);
    }

    &__subtitle {
      color: var(--primary);
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
    }

    &__info {
      margin-top: $grid-gutter-20;
      margin-bottom: $grid-gutter-width;

      &-title {
        color: var(--info);
        font-size: $font-size-lg;
        margin-bottom: 0;
      }

      &-text {
        margin-top: $grid-gutter-20;
      }
    }

    &__print {
      color: var(--info);
      text-decoration: underline;
      font-weight: $vb-font-weight-semibold;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: $grid-gutter-width / 6;

      @media print {
        display: none;
      }
    }

    &__ambient {
      display: flex;
      align-items: center;
      color: $success;
      font-size: $font-size-md;
      margin-bottom: 0;

      @media print {
        display: none;
      }
    }
  }

</style>